module.exports = __webpack_public_path__ + "img/exmple-2.616d2044.png";